<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.textContent}}</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">{{data.cancelText}}</button>
  <button mat-button [mat-dialog-close]="data.isConfirmed" cdkFocusInitial>{{data.okText}}</button>
</div>
